import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/services/shared.service';
import * as moment from "moment-timezone";
import { ReservationService } from 'src/app/services/reservation.service';
import { ToastrModule } from 'ngx-toastr';

@Component({
  selector: 'app-reserve-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class ReserveAddComponent implements OnInit, OnDestroy {
  currentChat: any;
  vtuber: any;
  currentEventIndex: number = -1;
  startTime: any = '';
  duration: number = 0;
  message: string = '';
  startTimes: any[];
  events: any[];
  RESERVATION_LIMIT: number = 2;
  remainingMinutes: number = 0;
  activeReservations: number;

  constructor(
    public auth: AuthService,
    private router: Router,
    private shared: SharedService,
    private toastr: ToastrModule
  ) {}

  ngOnInit() {
    if (this.auth.user.avatar === undefined) {
      this.router.navigate(['/avatar/select']);
      return;
    }

    this.currentChat = this.shared.getCookie(SharedService.CURRENT_CHAT)

    if (this.currentChat === undefined) {
      window.history.back();
      return;
    }

    this.auth.getUserByUid(this.currentChat.vtuber.uid).subscribe(res => {
      if (res && res.length > 0) {
        this.vtuber = res[0]

        let now = Date.now()
        this.events = this.vtuber.events.filter(item => {
            let d = `${item.date} ${item.title.split("~")[1]}:00`;
            let date = new Date(d.replace(/-/g,"/"));
            // let date = new Date(`${item.date} ${item.title.split("~")[1]}:00`)
            date.setDate(date.getDate() - 1)
            return item.is_publish === 1 && date.getTime() > now && this.auth.parseMonth(new Date(item.date)) === this.auth.parseMonth(now)
          })
          .sort((a, b) => {
            if (a.date > b.date) return 1;
            if (a.date < b.date) return -1;
            return 0;
          })

        this.getRemainingMinutes()
        if (this.events && this.events.length > 0) {
          this.currentEventIndex = 0
          this.getStartTimes()
        }

        // Active Reservations
        this.activeReservations = 0;
        if (this.auth.user.active_reservations) {
          this.auth.user.active_reservations.map(item => {
            if (item.vtuber_uid === this.vtuber.uid)
              this.activeReservations = item.count
          })
        }
      }
    })

  }

  getRemainingMinutes() {
    this.vtuber.plans.map(vplan => {
      this.auth.user.plans.map(uplan => {
        if (vplan.uid === uplan.plan_uid) {
          this.remainingMinutes = parseInt(vplan.period) - parseInt(uplan.used_period);
        }
      })
    })
  }

  ngOnDestroy() {
    this.shared.removeCookie(SharedService.CURRENT_CHAT)
  }

  columnHeaderText(date) {
    return ['日', '月', '火', '水', '木', '金', '土'][date.getDay()];
  }

  getEventLabel(event) {
    return moment(event.date).format("MM月DD日(") + this.columnHeaderText(new Date(event.date)) + ") " + event.title;
  }

  getStartTimes() {
    if (this.currentEventIndex >= 0) {
      let times = this.events[this.currentEventIndex].title.split('~');
      let reservations = this.events[this.currentEventIndex].reservations ? this.events[this.currentEventIndex].reservations : [];
      let start: number = parseInt(times[0].split(':')[0]) * 60 + parseInt(times[0].split(':')[1]);
      let end: number = parseInt(times[1].split(':')[0]) * 60 + parseInt(times[1].split(':')[1]);

      let res = [];
      let canAdd = false;
      for (let i = start; i <= end - 5; i+= 5) {
        canAdd = true;
        reservations.map(item => {
          if (i >= item.start && i < item.end) canAdd = false;
        })

        if (canAdd)
          res.push(("00" + Math.floor(i / 60)).slice(-2) + ":" + ("00" + (i - Math.floor(i / 60) * 60)).slice(-2))
      }

      if (res.length > 0) {
        this.startTime = res[0];
      } else {
        this.startTime = '';
      }

      this.startTimes = res
      return;
    }

    this.startTimes = []
  }

  getDurations() {
    let res = []
    let limit = 60;
    if (this.currentEventIndex >= 0 && this.startTime !== '') {
      let times = this.events[this.currentEventIndex].title.split('~');
      let end: number = parseInt(times[1].split(':')[0]) * 60 + parseInt(times[1].split(':')[1]);
      let start: number = parseInt(this.startTime.split(':')[0]) * 60 + parseInt(this.startTime.split(':')[1]);

      let reservations = this.events[this.currentEventIndex].reservations ? this.events[this.currentEventIndex].reservations : [];

      reservations.map(item => {
        if (start < item.start && end >= item.start) end = item.start
      })

      limit = end - start > 60 ? 60 : end - start;
    }

    if (limit > this.remainingMinutes) limit = this.remainingMinutes

    for (let i = 5; i <= limit; i = i + 5) {
      res.push(i)
    }

    return res;
  }

  checkReservationNum() {
    if (this.activeReservations && this.activeReservations >= this.RESERVATION_LIMIT) return true;

    return false;
  }

  canSend() {
    return this.checkReservationNum() === false && this.startTime !== '' && this.duration >= 1 && this.message.length > 0;
  }

  send() {
    let time = parseInt(this.startTime.split(':')[0]) * 60 + parseInt(this.startTime.split(':')[1]) + this.duration * 1;
    let end = ("00" + Math.floor(time / 60)).slice(-2) + ":" + ("00" + (time - Math.floor(time / 60) * 60)).slice(-2)

    this.shared.setCookie(SharedService.CURRENT_RESERVE, {
      event_uid: this.events[this.currentEventIndex].uid,
      reserveAt: this.events[this.currentEventIndex].date,
      start: this.startTime,
      end: end,
      message: this.message,
      duration: this.duration,
      user_uid: this.auth.user.uid,
      vtuber_uid: this.vtuber.uid,
      vtuberPhoto: this.vtuber.photoURL,
      vtuberName: this.vtuber.displayName,
      status: ReservationService.RESERVED
    })

    this.shared.redirect('/reserve/confirm');
  }
}
